import React, { createContext, useContext, useState, useMemo } from "react";
import Fuse from "fuse.js";

const SearchContext = createContext();

export function useSearch() {
  return useContext(SearchContext);
}

export function SearchProvider({ children }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchOptions, setSearchOptions] = useState({});

  const fuse = useMemo(() => {
    if (!searchOptions.data || !searchOptions.keys) return null;

    return new Fuse(searchOptions.data, {
      keys: searchOptions.keys,
      threshold: 0.3,
      ...searchOptions.fuseOptions,
    });
  }, [searchOptions]);

  const filteredData = useMemo(() => {
    if (!fuse || !searchQuery) return searchOptions.data;

    return fuse.search(searchQuery).map((result) => result.item);
  }, [fuse, searchQuery, searchOptions.data]);

  const value = useMemo(
    () => ({
      searchQuery,
      setSearchQuery,
      setSearchOptions,
      filteredData,
    }),
    [searchQuery, setSearchQuery, setSearchOptions, filteredData]
  );

  return (
    <SearchContext.Provider value={value}>{children}</SearchContext.Provider>
  );
}
